import common from "@well-b/well-b-shared";

export const MIN_SELF_BUDGET_LOAD = 500;

export const MIN_SELF_BUDGET_LOAD_BY_SYSTEM_ID = {
    [common.themeNames.tenBis]: 0
};
